import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    // Extracts the pathname property (e.g., "/about") from the current location object.
    const { pathname } = useLocation();

    // This useEffect hook will run every time the pathname changes.
    useEffect(() => {
        // "document.documentElement.scrollTo" is the same as "window.scrollTo" but
        // more browser-compatible.
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant', // Optional: Use 'auto' or 'instant' for immediate scrolling.
        });
    }, [pathname]); // The effect dependencies array with 'pathname' ensures this runs only on a route change.

    // This component does not render anything to the DOM.
    return null;
}

export default ScrollToTop;